import { useState } from 'react';
import BuyCreditsModal from './BuyCreditsModal';
import './PaywallModal.css';

export default function PaywallModal({
  isOpen,
  onClose,
  onCheckout,
  usage = null,
  billingMode = null,
  variant = 'default',
  checkoutReturnUrl = null,
}) {
  const [showBuyCredits, setShowBuyCredits] = useState(false);

  if (!isOpen) return null;

  const isNewUser = !usage?.hasBilling;
  const useCreditFlow = isNewUser || billingMode === 'credits' || variant === 'insufficient';

  if (showBuyCredits) {
    return (
      <BuyCreditsModal
        isOpen
        onClose={() => {
          setShowBuyCredits(false);
          onClose();
        }}
        variant={variant === 'insufficient' ? 'insufficient' : 'default'}
        checkoutReturnUrl={checkoutReturnUrl}
      />
    );
  }

  const title =
    variant === 'insufficient'
      ? 'Insufficient credits'
      : 'Ready to create more videos?';

  const subtitle =
    variant === 'insufficient'
      ? 'Your credit balance is too low. Top up to continue.'
      : useCreditFlow
        ? 'Buy credits to start generating videos in this project.'
        : 'Add a payment method to keep generating in this project.';

  return (
    <div className="paywall-backdrop" role="presentation" onClick={onClose}>
      <div
        className="paywall-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="paywall-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="paywall-header">
          <h2 id="paywall-title">{title}</h2>
          <p>{subtitle}</p>
        </header>

        {variant !== 'insufficient' && (
          <ul className="paywall-benefits">
            <li>Continue generating additional videos</li>
            <li>Keep all your current project progress</li>
            <li>Manage billing anytime from your account</li>
          </ul>
        )}

        {usage && usage.hasBilling && variant !== 'insufficient' && (
          <div className="paywall-usage">
            <p>
              Current usage: <strong>${usage.totalCostDollars?.toFixed(2) || '0.00'}</strong>
            </p>
            <p>{usage.totalVideoSeconds?.toFixed(1) || '0'} seconds generated</p>
          </div>
        )}

        {usage && variant === 'insufficient' && (
          <div className="paywall-usage">
            <p>
              Balance: <strong>${(usage.creditBalanceDollars ?? 0).toFixed(2)}</strong>
            </p>
          </div>
        )}

        <div className="paywall-actions">
          {useCreditFlow ? (
            <button
              type="button"
              className="paywall-primary"
              onClick={() => setShowBuyCredits(true)}
            >
              Buy credits
            </button>
          ) : (
            <button type="button" className="paywall-primary" onClick={onCheckout}>
              Add payment method
            </button>
          )}
          <button type="button" className="paywall-secondary" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
